<template>
    <div v-if="showModal" id="stock_modal" class="ui middle aligned center aligned grid">
        <div class="ui column segments">
            <div id="header" class="ui left aligned segment">
                <h3 class="ui header">{{ center.name + " " + constantNames[stockOrder.type] + " 내역 (" + partner.name + ")" }} </h3>
            </div>
            <div id="body" class="ui segment">
                <table class="ui very basic table">
                    <thead>
                        <tr>
                            <th class="collapsing">상품명</th>
                            <!-- <th class="collapsing">재고수량</th>
                            <th class="collapsing">최종수량</th> -->
                            <th class="collapsing">{{ constantNames[stockOrder.type] }}수량</th>
                            <th>{{ constantNames[stockOrder.type] }}메모</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(product, index) in stockOrder.products" :key="index">
                            <td class="collapsing">{{ product.name }}</td>
                            <!-- <td class="collapsing">{{ getProductStock(product._id) }}</td>
                            <td class="collapsing">
                                {{ getProductStock(product._id) + ((stockOrder.type == constant.STOCK_ADD) ? product.count : -product.count) }}
                            </td> -->
                            <td class="collapsing">{{ product.count }}
                                <!-- <div class='ui fluid small input'>
                                    <input type="number" v-model.number="product.count" disabled>
                                </div> -->
                            </td>
                            <td>
                                <div class='ui fluid small input'>
                                    <input type="text" v-model="product.memo" disabled>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div id="footer" class="ui right aligned segment">
                <div v-if="isHeader && !stockOrder.confirmedAt" class="ui primary left labeled icon button" @click="confirm">
                    <i class="checkmark icon"></i>확정
                </div>
                <div class="ui button" @click="close">닫기</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: function() {
        return {
            showModal: 0,
            center: 0,
            partner: 0,
            partnerProducts: 0,
            stockOrder: 0,
            onChange: 0,
        }
    },
    created: function() {
        this.showModal = false;
    },
    mounted: function() {
        window.addEventListener('keyup', (e) => { if (this.showModal && e.keyCode === 27) this.close(); });
        this.$event.set("stockOrderDetail_open", this.open);
    },
    beforeDestroyed: function() {
        this.$event.clear("stockOrderDetail_open");
    },
    methods: {
        open(params) {
            this.showModal = true;
            this.stockOrder = params.stockOrder;
            this.center = params.center;
            this.partner = params.partner;
            this.partnerProducts = params.partnerProducts;
            this.onChange = params.onChange;
        },
        close() {
            this.showModal = false;
        },
        confirm() {
            this.$event.call("openLoading");
            this.$api.confirmStockOrder(this.stockOrder._id, (resData) => {
                this.$event.call("closeLoading");
                if (resData.error) {
                    alert(resData.error.message);
                } else {
                    this.close();
                    if (this.onChange) this.onChange();
                }
            });
        },
        getProductStock(_productId) {
            for (const p of this.partnerProducts) {
                if (p._id == _productId) {
                    return p.centerStocks[this.center._id].count;
                }
            }
            return null;
        },
    },
    computed: {
        isHeader: function() {return this.$store.getters.isHeader; },
        centers: function() { return this.$store.getters.centers; },
        partners: function() { return this.$store.getters.partners; },
        constant: function() { return this.$store.getters.constant; },
        constantNames: function() {return this.$store.getters.constantNames; },
    },
}
</script>

<style>
#stock_modal {
    position: fixed;
    left: 0;
    top: 0;
    margin: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0,0,0,0.8);
}

#stock_modal .column {
    min-width: 600px;
    max-width: 600px;
}

#stock_modal #header {
    padding: 20px 30px;
}

#stock_modal #body {
    padding: 50px;
}

#stock_modal #body .ui.form {
    padding: 10px;
}

#stock_modal #footer {
    padding: 20px 20px;
    background-color: #eee;
}

#stock_modal .ui.form {
    padding: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/StockModal_Detail.vue